import * as types from '../mutation-types'

export const setTitle = function ({ store, dispatch }, title) {
  dispatch(types.SET_TITLE, title)
}

export const setTheme = function ({ store, dispatch }, theme) {
  dispatch(types.SET_THEME, theme)
}



// WEBPACK FOOTER //
// ./src/vuex/view/actions.js